import {createLogger} from '~/shared/logging';

import {makeReducer, composeReducers} from '../../redux-toolbelt';

import {setCurrentModal, setCurrentModalArgs} from './currentModalActions';

const logger = createLogger('currentModalReducer');

export type CurrentModalState = {
  name: string;
  args?: Record<string, any>;
} | null;

export default composeReducers<CurrentModalState>(
  makeReducer<CurrentModalState>(
    {
      [setCurrentModal.TYPE]: (currentState, {payload: requestedModal}: ReturnType<typeof setCurrentModal>) => {
        const currentModalName = currentState?.name;
        const requestedModalName = requestedModal?.name;

        if (currentModalName === 'update_user_details' && requestedModalName !== 'successModal') {
          logger.warn('currentModal\'s reducer prevented new modal opening', {currentModalName, requestedModalName});
          return currentState;
        }

        return requestedModal;
      },
      [setCurrentModalArgs.TYPE]: (currentState, {payload: args}: ReturnType<typeof setCurrentModalArgs>) => {
        if (!currentState) {
          return currentState;
        }
        return {
          ...currentState,
          args: {
            ...currentState.args,
            ...(args || {}),
          },
        };
      },
    },
    {defaultState: null},
  ),
);
